<!-- SearchFilters.svelte -->
<script>
    import { createEventDispatcher } from 'svelte';
    
    export let categories = [];
    
    const dispatch = createEventDispatcher();
    let selectedCategories = [];
    let searchInput = '';
    
    // Category display names (translations from English to Swedish)
    const categoryNames = {
      'seafood': 'Fisk & Skaldjur',
      'meat': 'Kött & Chark',
      'vegetables': 'Grönsaker',
      'fruit': 'Frukt & Bär',
      'snacks': 'Snacks & Godis',
      'kitchenware': 'Köksredskap',
      'dairy': 'Mejeri',
      'pantry': 'Skafferi'
    };
    
    // Get the display name for a category
    function getCategoryName(category) {
      return categoryNames[category] || category;
    }
    
    function handleCategoryChange(category) {
      const index = selectedCategories.indexOf(category);
      if (index === -1) {
        selectedCategories = [...selectedCategories, category];
      } else {
        selectedCategories = selectedCategories.filter(c => c !== category);
      }
      dispatch('categoryChange', selectedCategories);
    }
    
    function handleSearchInput() {
      dispatch('search', searchInput);
    }

    function clearSearch() {
      searchInput = '';
      dispatch('search', '');
    }

    function clearFilters() {
      selectedCategories = [];
      dispatch('categoryChange', []);
    }
</script>
  
<div class="search-filters">
  <div class="search-box">
    <input 
      type="text" 
      placeholder="Sök bland veckans erbjudanden..." 
      bind:value={searchInput}
      on:input={handleSearchInput}
    />
    {#if searchInput}
      <button class="clear-search-button" on:click={clearSearch}>×</button>
    {:else}
      <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
    {/if}
  </div>
  
  <div class="category-filters">
    <div class="filter-header">
      <h3>Filtrera efter kategori</h3>
      {#if selectedCategories.length > 0}
        <button class="clear-filters-button" on:click={clearFilters}>
          Rensa
        </button>
      {/if}
    </div>
    
    <div class="categories-list">
      {#each categories as category}
        <label class="category-checkbox" class:active={selectedCategories.includes(category)}>
          <input 
            type="checkbox" 
            value={category}
            checked={selectedCategories.includes(category)}
            on:change={() => handleCategoryChange(category)}
          />
          <span class="checkmark"></span>
          <span class="category-name">{getCategoryName(category)}</span>
          <span class="category-icon">
            {#if category === 'seafood'}
              🐟
            {:else if category === 'meat'}
              🥩
            {:else if category === 'vegetables'}
              🥦
            {:else if category === 'fruit'}
              🍎
            {:else if category === 'snacks'}
              🍿
            {:else if category === 'kitchenware'}
              🍳
            {:else if category === 'dairy'}
              🧀
            {:else if category === 'pantry'}
              🌾
            {:else}
              📦
            {/if}
          </span>
        </label>
      {/each}
    </div>
  </div>

  {#if selectedCategories.length > 0}
    <div class="active-filters">
      <span class="active-filters-label">Aktiva filter:</span>
      <div class="filter-tags">
        {#each selectedCategories as category}
          <div class="filter-tag">
            {getCategoryName(category)}
            <button on:click={() => handleCategoryChange(category)}>×</button>
          </div>
        {/each}
      </div>
    </div>
  {/if}
</div>
  
<style>
  .search-filters {
    margin-bottom: 20px;
  }
  
  .search-box {
    position: relative;
    margin-bottom: 20px;
  }
  
  .search-box input {
    width: 100%;
    padding: 12px 40px 12px 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  }
  
  .search-box input:focus {
    border-color: #e91e63;
    box-shadow: 0 2px 8px rgba(233, 30, 99, 0.2);
  }
  
  .search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    pointer-events: none;
  }
  
  .clear-search-button {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #999;
    font-size: 20px;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background-color 0.2s;
  }
  
  .clear-search-button:hover {
    background-color: #f0f0f0;
  }
  
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
  }
  
  .category-filters h3 {
    margin: 0;
    font-size: 16px;
    color: #333;
  }
  
  .clear-filters-button {
    background: none;
    border: none;
    color: #e91e63;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    padding: 0;
    text-decoration: underline;
  }
  
  .categories-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  
  .category-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 6px;
    transition: background-color 0.2s;
    position: relative;
  }
  
  .category-checkbox:hover {
    background-color: #f5f5f5;
  }
  
  .category-checkbox.active {
    background-color: #fce4ec;
  }
  
  .category-checkbox input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
  
  .checkmark {
    height: 18px;
    width: 18px;
    background-color: #fff;
    border: 2px solid #ddd;
    border-radius: 4px;
    margin-right: 10px;
    position: relative;
    transition: background-color 0.2s, border-color 0.2s;
  }
  
  .category-checkbox:hover .checkmark {
    border-color: #e91e63;
  }
  
  .category-checkbox input:checked ~ .checkmark {
    background-color: #e91e63;
    border-color: #e91e63;
  }
  
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
    left: 5px;
    top: 1px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  
  .category-checkbox input:checked ~ .checkmark:after {
    display: block;
  }
  
  .category-name {
    font-size: 14px;
    color: #333;
    flex: 1;
  }
  
  .category-icon {
    font-size: 16px;
    margin-left: 5px;
  }
  
  .active-filters {
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
  }
  
  .active-filters-label {
    display: block;
    font-size: 14px;
    color: #666;
    margin-bottom: 10px;
  }
  
  .filter-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .filter-tag {
    display: inline-flex;
    align-items: center;
    background-color: #e91e63;
    color: white;
    padding: 6px 10px;
    border-radius: 20px;
    font-size: 12px;
  }
  
  .filter-tag button {
    background: none;
    border: none;
    color: white;
    margin-left: 5px;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    width: 16px;
    height: 16px;
  }
</style>